<template>
	<div>
		<header class="sticky top-0 z-20">
			<div class="bg-white shadow py-4 relative z-10">
				<div class="container mx-auto px-4 flex flex-col items-center sm:flex-row sm:items-end md:px-8 md:text-3xl">
					<img class="h-5 mx-auto sm:h-8 sm:ml-0" :src="require('@/assets/dish-outdoors.svg')">
					<a class="mt-3 text-xl text-dish-red font-bold leading-none sm:text-3xl sm:mt-0" :href="phoneUrl">{{ phoneNumber }}</a>
				</div>
			</div>
		</header>

		<main class="overflow-x-hidden leading-tight">
			<common-header text="" class='text-center' :class="{'-mt-48': !isThanks }">
				<p class="px-4 text-3xl text-dish-red font-bold tracking-tight sm:text-5xl sm:-mt-8">Thanks for entering!</p>
				<p class="px-4 text-xl mt-4 -mb-8 mx-auto sm:text-3xl sm:mb-0 lg:max-w-2xl" v-if="isThanks">Make sure to keep an eye on your email for information on earning more entries!</p>
				<img :class="{'pt-64': !isThanks}" class="mt-16 mb-32 mx-auto relative z-10" :src="require('@/assets/rvready/PostEntry/Badge.png')">
			</common-header>

			<section class="bg-white -mt-64 pt-32 lg:-mt-24 lg:pt-24 border-t-4 border-gray-900" :class="{'': isThanks}">
				<div class="container mx-auto py-8 px-4">
					<div class="md:flex items-center mx-auto md:max-w-3xl lg:max-w-5xl">
						<div class="md:w-1/2 md:pr-4 text-center xl:w-2/5">
							<div class="bg-gray-900 text-white mx-auto py-2 max-w-sm lg:py-1">
								<p class="text-2xl font-light lg:text-4xl lg:leading-snug">Deal Of The Week</p>
								<p class="text-sm lg:text-base">STARTING 3/24</p>
							</div>
							<img class="w-full mt-6 mx-auto max-w-xs md:hidden" :src="require('@/assets/rvready/PostEntry/Bundle.png')">
							<p class="mt-6 text-dish-red text-7xl font-extrabold">Save $60</p>
							<p class="text-3xl">On Any DISH Outdoors Satellite Antenna Bundle</p>

							<div class="mt-6 text-center border-4 border-dashed border-black py-2 px-4">
								<p class="leading-tight sm:text-xl">Use Code At Checkout: <span class="block font-bold text-2xl text-dish-red tracking-wide sm:text-4xl">SPRING60</span></p>
								<p class="text-sm">EXPIRES 3/30</p>
							</div>
						</div>
						<div class="hidden md:block w-1/2 pl-4 xl:w-3/5">
							<img :src="require('@/assets/rvready/PostEntry/Bundle.png')">
						</div>
					</div>

					<div class="flex">
						<a href="https://www.dishformyrv.com/bundles/" class="bg-dish-red text-white rounded-full py-1 px-8 text-2xl mx-auto mt-8">Grab This Deal</a>
					</div>
				</div>
			</section>
			
			<section class="py-12">
				<div class="container mx-auto px-4">
					<h2 class="capitalize text-center font-semibold text-2xl sm:text-3xl md:text-4xl">Enhancing Your Entertainment Experience is Easy</h2>

					<div class="md:flex">
						<a v-for="(graphic, index) in graphics" :key="index" :href="graphic.url" target="_blank" class="block mt-12 w-full no-underline text-black px-4 md:w-1/3">
							<img class="w-full h-auto block" :src="graphic.image">
							<p class="w-full px-2 text-center mt-2 text-black no-underline font-medium text-base capitalize sm:text-xl">{{ graphic.name }}</p>
						</a>
					</div>
				</div>
			</section>

			<section class="bg-white">
				<div class="container mx-auto px-4 py-8 md:flex flex-wrap justify-center justify-around lg:Flex-no-wrap">
					<a href="https://www.rvrepairclub.com/">
						<img class="mx-auto h-16 w-auto lg:h-12 xl:h-16" :src="require('@/assets/rvready/RV-Repair-Club.png')">
					</a>
					<a href="https://thousandtrails.com/">
						<img class="mx-auto h-16 w-auto mt-8 md:mt-0 lg:h-12 xl:h-16" :src="require('@/assets/rvready/Thousand-Trails.png')">
					</a>
					<a href="https://harvesthosts.com/join-now/?utm_source=RVReadyCampaignLP&utm_medium=referral&utm_campaign=RVReadyCampaign">
						<img class="mx-auto h-16 w-auto mt-8 md:mt-0 lg:h-12 xl:h-16" :src="require('@/assets/rvready/Harvest-Hosts.png')">
					</a>
					<a href="https://www.escapees.com/">
						<img class="mx-auto h-16 w-auto mt-8 md:mt-0 lg:h-12 xl:h-16" :src="require('@/assets/rvready/Escapees.png')">
					</a>
				</div>
			</section>
			
			<section class="py-12">
				<div class="container mx-auto px-4">
					<h2 class="capitalize text-center font-semibold text-2xl sm:text-3xl md:text-4xl">Learn More About DISH Outdoors</h2>

					<div class="mt-8 md:flex">
						<a v-for="(video, index) in videos" :key="index" :href="video.url" target="_blank" class="w-full no-underline text-black px-4 md:w-1/2">
							<img class="w-full h-auto block" :src="video.img">
							<p class="w-full px-2 text-center mt-2 text-black no-underline font-medium text-base capitalize sm:text-xl">{{ video.name }}</p>
						</a>
					</div>
				</div>
			</section>
			
			<section class="py-12 bg-white">
				<div class="container mx-auto px-4">
					<h1 class="capitalize text-center leading-tight font-bold text-2xl mx-auto sm:text-3xl md:text-4xl">DISH Outdoors is the Perfect Addition to any Adventure</h1>
					<p class="text-center font-medium text-xl mt-2 sm:text-xl md:text-3xl">See what we add to different adventures</p>
					
					<flickity ref="flickity" class="relative carousel-enabled max-w-xs mx-auto sm:max-w-full lg:carousel-disabled mt-8 md:-mx-4 lg:flex lg:justify-center" :options="{ watchCSS: true, pageDots: false, contain: true, wrapAround: true, cellAlign: 'left' }">
						<a v-for="(add, index) in additions" :key="index" :href="add.url" target="_blank" class="w-full no-underline text-black px-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
							<img @load="$refs['flickity'].resize()" class="w-full h-auto block mx-auto p-6" :src="add.img">
							<p class="w-full px-4 text-center text-dish-red no-underline font-bold text-lg uppercase">{{ add.name }}</p>
						</a>
					</flickity>
				</div>
			</section>

			<section class="px-4 py-3 font-semibold leading-tight bg-dish-red text-white text-center sticky bottom-0 z-30 sm:relative">
				<a :href="phoneUrl" class="text-xl sm:text-4xl md:text-5xl">Talk to an Expert <span class="inline-block">{{ phoneNumber }}</span></a>
			</section>
		</main>
	</div>
</template>

<script>
	import Flickity from 'vue-flickity'

	import CommonHeader from '@/views/RVReady/Header'

	export default {
		components: {
			Flickity,

			CommonHeader,
		},

		computed: {
			phoneUrl() {
				return `tel:${this.phoneNumber}`
			}
		},

		created() {
			if (window.location.search.includes('thanks')) {
				this.isThanks = true

			}
		},

		data() {
			return {
				additions: [{
					name: 'Motorhome',
					url: 'https://get.dishformyrv.com/dish-satellite-rv-motorhome',
					img: require('@/assets/rvready/Icons/RV.svg'),
				}, {
					name: 'Tailgating',
					url: 'https://get.dishformyrv.com/tailgating',
					img: require('@/assets/rvready/Icons/Tailgating.svg'),
				}, {
					name: 'Outdoorsman',
					url: 'https://get.dishformyrv.com/outdoorsmen',
					img: require('@/assets/rvready/Icons/Outdoorsman.svg'),
				}, {
					name: 'Travel Trailer',
					url: 'https://get.dishformyrv.com/travel-trailer',
					img: require('@/assets/rvready/Icons/Travel Trailer.svg'),
				}],

				graphics: [{
					name: 'How To Get HD TV Outdoors',
					url: 'https://get.dishformyrv.com/hubfs/rvready-2020/How%20To%20Get%20HD%20TV%20Outdoors.pdf',
					image: require('@/assets/rvready/Graphics/How-to-get-HD-TV-Outdoors.jpg'),
				}, {
					name: 'Must Have Accessories',
					url: 'https://get.dishformyrv.com/hubfs/rvready-2020/Must%20Have%20RV%20Accessories.pdf',
					image: require('@/assets/rvready/Graphics/Must-Have-Accessories.jpg'),
				}, {
					name: 'Which Antenna Is Best For You?',
					url: 'https://get.dishformyrv.com/hubfs/rvready-2020/Satellite%20Antenna%20Infographic.pdf',
					image: require('@/assets/rvready/Graphics/Satellite-Antenna-Graphic.jpg'),
				}],

				videos: [{
					name: 'DISH Portable Satellite Antenna Options',
					url: 'https://www.youtube.com/watch?v=GO18W7wgU9c',
					img: require('@/assets/rvready/Videos/DISH-Portable-Satellite-Antenna-Options.jpg'),
				}, {
					name: 'DISH Wally Accessories',
					url: 'https://www.youtube.com/watch?v=ery50oEGAik',
					img: require('@/assets/rvready/Videos/DISH-Wally-Accessories.jpg'),
				}, {
					name: 'Pay As You Go HD TV Anywhere You Travel With DISH Outdoors',
					url: 'https://www.youtube.com/watch?v=AguCGRStNlM',
					img: require('@/assets/rvready/Videos/Pay-As-You-Go-HD-TV-Anywhere-You-Travel-with-DISH-Outdoors.jpg'),
				}],

				isThanks: false,
				phoneNumber: '1-877-597-8663',
			}
		},
	}
</script>

<style scoped>
	@responsive {
		.carousel-enabled:after {
			content: 'flickity';
			display: none;
		}

		.carousel-disabled:after {
			content: '';
			display: none;
		}
	}
</style>

<style>
	/* purgecss start ignore */
	.flickity-button {
		@apply bg-dish-red text-white border-2 border-white border-solid;
	}

	.flickity-button path { 
		@apply fill-current;
	}

	.flickity-button-icon { 
		@apply mx-auto w-8 h-8;
	}

	.flickity-button:hover {
		@apply bg-dish-red text-white cursor-pointer;
	}

	.flickity-prev-next-button {
		@apply w-12 h-12;
	}

	.flickity-prev-next-button.previous {
		left: -1rem!important;
	}

	.flickity-prev-next-button.next {
		right: -1rem!important;
	}

	.flickity-image {
		transition: opacity 0.4s;
		opacity: 0;
	}

	.flickity-lazyloaded, .flickity-lazyerror {
		opacity: 1;
	}

	.pinterest-holder > span {
		@apply max-w-full w-full !important;
	}
	/* purgecss end ignore */
</style>
